function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import Button from 'components/Form/Button';
import App from 'modules/App';
import styles from './StandardActions.pcss';
const StandardActions = ({ hasChanges, isInProgress, infoMessage })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.standardActions,
        children: [
            /*#__PURE__*/ _jsx(Button, {
                type: "reset",
                styleModifier: "primary",
                labelMessage: App.messages.buttons.cancel,
                isDisabled: !hasChanges || isInProgress,
                className: "btn"
            }),
            /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: App.messages.buttons.save,
                className: "btn btn--filled",
                isDisabled: !hasChanges,
                isInProgress: isInProgress
            }),
            infoMessage && /*#__PURE__*/ _jsx("p", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage))
            })
        ]
    });
};
export default StandardActions;
